// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useEffect } from 'react'
import { RoutedApp } from '../lib'
import logo from '../logo.svg'


const MeApp: React.FC = () => {
  const gettext: (value: string) => string = (value) => value

  useEffect(() => {
    document.title = "Personal Dashboard - Molano Cloud"
  }, [])

  return (
    <RoutedApp logo={logo} name={gettext("My Molano")} ready={true}></RoutedApp>
)}

export default MeApp
